import { Form, Formik } from 'formik';
import * as Yup from "yup";
import { string } from "yup";
import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import CloseIcon from '@mui/icons-material/Close';
import FormikControls from '../form-components/FormikControls';
import { navigation1, navigation3 } from '../../../../utilityFunctions';
const ForgotPasswordModal = ({ onSubmit, data = {}, onClose = () => { }, titleName, isForgotPassword = false }) => {
    const [isDisabled, setIsDisabled] = useState(false);
    const initialValues = isForgotPassword ?
        {
            loginId: isForgotPassword ? data?.loginId : '',
            newPassword: '',
            ConfirmPassword: '',

        }
        : {
            oldPassword: data?.oldPassword,
            newPassword: '',
            ConfirmPassword: '',
        }
    useEffect(() => {
        if (!isForgotPassword) {
            const oldPasswordInput = document.getElementById('oldPassword');
            if (oldPasswordInput) {
                oldPasswordInput.focus(); // Focus the input field
                oldPasswordInput.click(); // Optionally simulate a click (if needed)
            }
            setTimeout(() => {
                setIsDisabled(true); // Disable after interaction
            }, 0);
        } else {
            setIsDisabled(true); // Disable after interaction
        }
    }, [isForgotPassword]);

    const validationSchema = Yup.object(isForgotPassword ? {
        loginId: Yup.string().required("Required"),
        newPassword: string().required("Required"),
        ConfirmPassword: string().required("Required"),
    } : {
        oldPassword: Yup.string().required("Required"),
        newPassword: string().required("Required"),
        ConfirmPassword: string().required("Required"),
    }
    );
    return (
        <>
            {
                Object.keys(data).length > 0 &&
                <Box className='fogetPasswordUpdate'>
                    <Box className="fogetPasswordUpdate--content">
                        <div className='fogetPasswordUpdate-header'>
                            <LockIcon sx={{ width: '24px', height: '24px', color: '#004F9E' }} /> {titleName}
                        </div>
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={onSubmit}
                        >
                            {({ values, setFieldValue, submitForm }) => {
                                return (
                                    <Form>
                                        <div className="input--wrapper">
                                            <FormikControls
                                                control="input"
                                                type="text"
                                                id={isForgotPassword ? 'loginId' : 'oldPassword'}
                                                name={isForgotPassword ? 'loginId' : 'oldPassword'}
                                                label={isForgotPassword ? 'User ID' : "Old Password"}
                                                autoComplete="off"
                                                autoFocus={true}
                                                disabled={isDisabled}
                                            />
                                        </div>
                                        <div className="input--wrapper">
                                            <FormikControls
                                                control="input"
                                                type="password"
                                                id='newPassword'
                                                name="newPassword"
                                                label="Set New Profile Password"
                                                autoComplete="off"
                                                onKeyDown={(e) => {
                                                    navigation1(e, 'newPassword', 'oldPassword')
                                                }}
                                            />
                                        </div>
                                        <div className="input--wrapper">
                                            <FormikControls
                                                control="input"
                                                type="password"
                                                id='ConfirmPassword'
                                                name="ConfirmPassword"
                                                label="Confirm Profile Password"
                                                autoComplete="off"
                                                onKeyDown={(e) => {
                                                    navigation1(e, 'submit', 'ConfirmPassword')
                                                }}
                                            />
                                        </div>
                                        <div
                                            className="submit--btn"
                                            onClick={(e) => {
                                                submitForm();
                                            }}
                                            tabIndex={0}
                                            id='submit'
                                            type="submit"
                                            onKeyDown={(e) => {
                                                navigation3(e, 'oldPassword', 'newPassword', () => { submitForm() })
                                            }}
                                        >
                                            SAVE NEW PASSWORD & GO BACK TO LOGIN
                                        </div>
                                    </Form>
                                )
                            }}

                        </Formik>

                    </Box>
                    <Box className='fogetPasswordUpdate-rightContainer'>
                        <Box >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                                <h4 style={{
                                    paddingTop: '2px',
                                    paddingBottom: '24px',
                                }}>Please note the following:</h4>
                                <CloseIcon onClick={onClose} />
                            </div>
                            <ul>
                                <li style={{
                                    fontSize: '14px',
                                    letterSpacing: '0.02em',
                                    margin: '0px 0px 30px 0px',


                                }}>
                                    1.A minimum 8 characters password contains a combination of special character, uppercase, lowercase letter and number are required.
                                </li>

                                <li style={{
                                    fontSize: '14px',
                                    letterSpacing: '0.02em',
                                    margin: '30px 0',


                                }}>
                                    2. If you can't access your account, click "Forgot Password" to receive a reset link on your registered email to create a new password.
                                </li>
                                <li style={{
                                    fontSize: '14px',
                                    letterSpacing: '0.02em',
                                    margin: '30px 0',


                                }}>
                                    3.Never share personal information in response to popups, emails, SMS, or calls. These are tactics used by fraudsters to obtain your credentials.
                                </li>
                                <li style={{
                                    fontSize: '14px',
                                    letterSpacing: '0.02em',
                                    margin: '30px 0',


                                }}>
                                    4.Always create a strong password, avoid
                                    reusing passwords, and keep it safe with you
                                </li>
                            </ul>
                        </Box>
                    </Box>
                </Box>
            }
        </>
    )
}

export default ForgotPasswordModal